import React, { useState } from "react";
import { Link } from "react-router-dom";
import { Button } from "react-bootstrap";
import "./AnnualMaskPurchaseGuide.css";

const COPY = {
  TH: {
    title: "คู่มือ Annual Mask Purchase",
    subtitle: "ขั้นตอนสำหรับเจ้าหน้าที่ ตั้งแต่สร้างรายการในรอบจัดซื้อจนถึงสร้าง Sale Order",
    calendar: "เปิด CPAP Follow-Up",
    overview: "ภาพรวมการทำงาน",
    flow: ["สร้างรายการ", "ส่งแพทย์ / ข้าม", "อัปโหลดใบรับรอง / ยืนยันข้าม", "บันทึกผลประกันสังคม", "เลือกหน้ากากและฝ่ายขาย", "กำหนดวันรับหน้ากาก", "สร้าง Sale Order"],
    start: "ก่อนเริ่ม",
    preparation: [
      "บันทึกนัด CPAP Follow-Up ของผู้ป่วยก่อน แล้วเปิดแท็บ Annual Mask Purchase ภายในนัดนั้น",
      "เตรียมชื่อรอบจัดซื้อ (Batch) เลือกแพทย์ที่มีอีเมล และเลือกหรืออัปโหลด CPAP Usage Report เป็น PDF ระบบยังต้องใช้ข้อมูลเหล่านี้ตอนสร้างรายการ แม้จะข้ามการส่งอีเมลภายหลัง",
      "หากใช้แบบฟอร์มของระบบ ให้ตรวจรายงาน Sleep Study และข้อมูล AHI, Min SpO₂, วันที่ตรวจ และแรงดัน CPAP ก่อนสร้างใบรับรอง",
    ],
    steps: [
      { title: "สร้าง Batch และรายการผู้ป่วย", items: [
        "ในแท็บ Annual Mask Purchase เลือก Batch ที่มีอยู่ หรือระบุชื่อ Batch ใหม่ แล้วสร้างรายการผู้ป่วย",
        "เปิดหน้า Annual Mask Purchase เพื่อดูรายการแยกตาม Batch ค้นหาด้วยชื่อ Batch, HN, ผู้ป่วย, แพทย์, ฝ่ายขาย หรือเลขคำสั่งซื้อ และกรองสถานะได้",
        "กดที่แถบสรุปของผู้ป่วยเพื่อเปิดรายละเอียดและปุ่มดำเนินการ ใช้ Clear filters เพื่อล้างการค้นหาและตัวกรอง",
      ] },
      { title: "สร้างใบรับรองและส่งแพทย์ หรือข้าม", items: [
        "แบบฟอร์มของระบบรองรับเฉพาะ Node LPH (Ladprao Hospital) กับแพทย์ C.Vatcharee หรือ S.Jindapa เท่านั้น",
        "Send doctor email สร้างใบรับรองแล้วส่งพร้อม CPAP Usage Report และ Sleep Study Report ไปยังอีเมลแพทย์ ส่วน Download ZIP ใช้ดาวน์โหลดทั้งสามไฟล์เพื่อส่งต่อเอง",
        "Node หรือแพทย์อื่นใช้แบบฟอร์มของหน่วยงานตนเองได้ กด Skip generation & doctor email เพื่อข้ามทั้งการสร้างใบรับรองและการส่งอีเมล ระบบบันทึกว่ารอใบรับรองที่ลงนามแล้ว โดยยังไม่เปิดหน้าต่างอัปโหลด",
      ] },
      { title: "อัปโหลดใบรับรองที่ลงนามแล้ว หรือยืนยันข้าม", items: [
        "เมื่อได้รับเอกสาร กด Upload signed cert แล้วเลือก PDF ที่แพทย์ลงนามแล้ว ใช้ได้ทั้งแบบฟอร์มของระบบและของหน่วยงานอื่น ตรวจไฟล์ผ่าน Review signed cert",
        "หากต้องการไปต่อโดยไม่อัปโหลด กด Skip signed certificate upload แล้วกด Confirm skip ในหน้าต่างยืนยัน การกด Cancel จะไม่เปลี่ยนรายการ ระบบบันทึกผู้ยืนยันและเวลาที่ข้ามขั้นตอน",
        "ระบบเปรียบเทียบแรงดันเมื่ออ่านข้อมูลได้ หากอ่านแรงดันไม่ได้หรือไม่มีค่าเดิม จะข้ามการเปรียบเทียบและไปต่อได้ หากพบแรงดันเปลี่ยน ระบบจะแสดงข้อความให้ตรวจเอกสาร",
        "อัปโหลดภายหลังได้ก่อนรายการถูกล็อก เมื่ออัปโหลดสำเร็จ ระบบจะล้างสถานะข้ามการอัปโหลด",
      ] },
      { title: "บันทึกผลประกันสังคม", items: [
        "ส่งเอกสารให้ประกันสังคมนอกระบบนี้ แล้วบันทึกผลจริงด้วย Passed หรือ Not passed",
        "ปุ่มบันทึกผลจะใช้ได้เมื่อมีใบรับรองที่ลงนามแล้ว หรือยืนยันข้ามการอัปโหลดแล้ว การข้ามไม่ได้หมายความว่าผ่านประกันสังคม",
        "หากต้องแก้ไขใบรับรองหลังบันทึก Passed ให้เปลี่ยนผลเป็น Not passed ก่อน เฉพาะรายการที่ยังไม่พร้อมจัดซื้อหรือสร้างคำสั่งซื้อ",
      ] },
      { title: "เลือกหน้ากากและผู้รับผิดชอบฝ่ายขาย", items: [
        "เมื่อผลเป็น Passed ให้เลือกหน้ากากที่มีสต็อกใน Purchase details และตรวจจำนวนคงเหลือกับ Lot",
        "เลือก Sales Representative ที่ยังใช้งานอยู่ หรือ Centerให้ครบก่อนกด Ready & create order",
      ] },
      { title: "กำหนดวันที่ผู้ป่วยจะได้รับหน้ากาก", items: ["เลือกวันที่ใน Expected mask receipt date แล้วกด Save date ก่อน Ready to Purchase วันที่แสดงเป็นตัวหนาในรายการและการแจ้งเตือนของบัญชีที่มี Annual Mask Access"] },
      { title: "ยืนยันและติดตาม Sale Order", items: [
        "กด Ready & create order ตรวจชื่อผู้ป่วย หน้ากาก และฝ่ายขายในหน้าต่างยืนยัน แล้วจึงยืนยัน ระบบจองหน้ากาก 1 ชิ้นและสร้าง Sale Order",
        "ใช้ลิงก์ Order เพื่อเปิดหน้า Sale Order และติดตามงานต่อ เมื่อมีคำสั่งซื้อแล้ว ระบบจะล็อกข้อมูลสำคัญของรายการ",
        "หากระบบแจ้งว่าสร้างคำสั่งซื้อไม่สำเร็จ ให้ตรวจสถานะและเลขคำสั่งซื้อก่อนใช้ปุ่ม Retry ที่ระบบแสดง เพื่อดำเนินการกับรายการเดิม",
      ] },
    ],
    permissions: "สิทธิ์การใช้งาน",
    roles: "เจ้าหน้าที่ที่มีสิทธิ์ super_admin หรือ admin ดำเนินการหลัก เช่น ส่งอีเมล ข้ามขั้นตอน อัปโหลด และบันทึกผลได้ บัญชีฝ่ายขาย/บัญชีดูงานตามสิทธิ์ของหน้า ส่วนการกู้คืนคำสั่งซื้อที่ค้างต้องมี Annual Mask Access หรือสิทธิ์ super_admin ปุ่มที่เห็นขึ้นอยู่กับสิทธิ์และสถานะรายการ",
    reminders: "ข้อควรจำ",
    notes: [
      "ปุ่มข้ามการสร้างใบรับรอง/ส่งอีเมล และปุ่มข้ามการอัปโหลดใบรับรอง เป็นคนละขั้นตอน",
      "การกด Skip ไม่ได้สร้างไฟล์ ไม่ได้ส่งอีเมล และไม่ได้อนุมัติผลประกันสังคมแทนผู้ใช้",
      "Batch คือกลุ่มจัดซื้อ ส่วนแต่ละรายการคือผู้ป่วยที่มีสถานะ เอกสาร หน้ากาก และคำสั่งซื้อของตนเอง",
    ],
  },
  EN: {
    title: "Annual Mask Purchase Guide",
    subtitle: "An operator guide from creating a batch item to creating its Sale Order.",
    calendar: "Open CPAP Follow-Up",
    overview: "Workflow overview",
    flow: ["Create case", "Send to doctor / skip", "Upload signed certificate / confirm skip", "Record Social Security result", "Select mask and sales", "Schedule mask receipt", "Create Sale Order"],
    start: "Before you start",
    preparation: [
      "Save the patient's CPAP Follow-Up event first, then open its Annual Mask Purchase tab.",
      "Prepare a batch name, select a doctor with an email address, and select or upload a CPAP Usage Report PDF. These are still required when creating the case, even if you later skip the doctor email.",
      "If using a system template, check the Sleep Study Report and the AHI, minimum SpO₂, study date, and CPAP pressure values before generating the certificate.",
    ],
    steps: [
      { title: "Create a batch and patient case", items: [
        "In the Annual Mask Purchase tab, select an existing batch or enter a new batch name, then create the patient case.",
        "Open Annual Mask Purchase to review cases grouped by batch. Search by batch, HN, patient, doctor, sales representative, or order number, and filter by status.",
        "Click a patient's summary to expand its details and workflow actions. Clear filters resets both search and status.",
      ] },
      { title: "Generate and send to the doctor, or skip", items: [
        "System templates support only LPH (Ladprao Hospital) with C.Vatcharee or S.Jindapa.",
        "Send doctor email generates the certificate and emails it with the CPAP Usage Report and Sleep Study Report. Download ZIP downloads all three files for manual delivery.",
        "Other nodes or doctors can use their own template. Click Skip generation & doctor email to skip both actions. The case is saved as awaiting a signed certificate; this button does not open the upload picker.",
      ] },
      { title: "Upload the signed certificate, or confirm skipping it", items: [
        "When the document is ready, click Upload signed cert and select the signed PDF. Both system templates and your node's own templates are accepted. Use Review signed cert to preview it.",
        "To continue without uploading, click Skip signed certificate upload, then Confirm skip in the dialog. Cancel leaves the case unchanged. The system records who confirmed the skip and when.",
        "Pressure is compared when readable. If the pressure cannot be read or the original setting is missing, comparison is skipped and you can continue. A detected change is shown for document review.",
        "You can upload later before the case is locked. A successful upload clears the upload-skip state.",
      ] },
      { title: "Record the Social Security result", items: [
        "Send the documents to Social Security outside this system, then record the actual result using Passed or Not passed.",
        "Result buttons become available after uploading the signed certificate or confirming the upload skip. Skipping does not mark the case as passed.",
        "To replace a certificate after recording Passed, change the result to Not passed first. This is available only before the case is ready to purchase or has an order.",
      ] },
      { title: "Select the mask and sales representative", items: [
        "After a Passed result, select an in-stock mask in Purchase details and check the available stock and lots.",
        "Select an available Sales Representative or Center before clicking Ready & create order.",
      ] },
      { title: "Schedule patient mask receipt", items: ["Choose the expected mask receipt date and click Save date before Ready to Purchase. The saved date appears in bold on the case and in notifications for all Annual Mask Access accounts."] },
      { title: "Confirm and track the Sale Order", items: [
        "Click Ready & create order. Check the patient, mask, and sales representative in the confirmation dialog. Confirming reserves one mask and creates the Sale Order.",
        "Use the Order link to open the Sale Order page and continue processing it. Important case fields are locked once an order exists.",
        "If order creation fails, check the case status and order number before using the displayed Retry action to continue the existing case.",
      ] },
    ],
    permissions: "Who can perform each action",
    roles: "Users with super_admin or admin roles perform the main workflow actions, including email, skips, uploads, and results. Sales/accounting accounts review work according to page permissions. Recovering a pending order requires Annual Mask Access or super_admin access. Available buttons depend on both role and case status.",
    reminders: "Remember",
    notes: [
      "Skipping certificate generation/doctor email and skipping signed certificate upload are separate steps.",
      "Skip does not create a file, send an email, or approve the Social Security result.",
      "A batch groups purchase cases. Each patient case has its own status, documents, mask, and order.",
    ],
  },
};

const UI = {
  TH: {
    navigation: "ขั้นตอนการใช้งาน", intro: "เริ่มต้นใช้งาน", step: "ขั้นตอน", of: "จาก",
    optional: "เลือกข้ามได้", previous: "ก่อนหน้า", next: "ขั้นตอนถัดไป", back: "กลับไปก่อนเริ่ม",
    reference: "ข้อมูลเพิ่มเติม", standard: "ดำเนินการตามปกติ", skip: "ข้ามขั้นตอนนี้",
    introText: "เตรียมข้อมูลให้พร้อม แล้วเลือกขั้นตอนทางซ้ายเพื่อดูวิธีใช้งานทีละขั้น",
    count: "7 ขั้นตอน · เลือกข้ามการส่งแพทย์และการอัปโหลดได้", language: "ภาษา",
  },
  EN: {
    navigation: "Workflow steps", intro: "Getting started", step: "Step", of: "of",
    optional: "Skip available", previous: "Previous", next: "Next step", back: "Back to preparation",
    reference: "Reference", standard: "Standard path", skip: "Skip this step",
    introText: "Prepare the case information, then choose a step to read the instructions one at a time.",
    count: "7 steps · Doctor delivery and upload can be skipped", language: "Language",
  },
};

const AnnualMaskPurchaseGuide = () => {
  const [language, setLanguage] = useState("TH");
  const [activeStep, setActiveStep] = useState(-1);
  const copy = COPY[language];
  const ui = UI[language];
  const step = activeStep >= 0 ? copy.steps[activeStep] : null;
  const hasPaths = activeStep === 1 || activeStep === 2;
  const pathStart = activeStep === 1 ? 1 : 0;
  const instructions = step ? step.items : copy.preparation;
  const selectStep = (index) => setActiveStep(index);

  return (
    <div className="annual-mask-guide" lang={language === "TH" ? "th" : "en"}>
      <header className="amg-header">
        <div>
          <div className="amg-eyebrow">CPAP FOLLOW-UP / GUIDE</div>
          <h2>{copy.title}</h2>
          <p>{copy.subtitle}</p>
        </div>
        <div className="amg-header-actions">
          <div className="amg-language" role="group" aria-label={ui.language}>
            {["TH", "EN"].map((value) => (
              <button key={value} type="button" className={language === value ? "is-active" : ""} aria-pressed={language === value} onClick={() => setLanguage(value)}>
                {value === "TH" ? "TH · ไทย" : "EN · English"}
              </button>
            ))}
          </div>
          <Button as={Link} to="/cpap-followup-calendar" variant="outline-primary" size="sm">{copy.calendar}</Button>
        </div>
      </header>

      <div className="amg-layout">
        <nav className="amg-navigation" aria-label={ui.navigation}>
          <div className="amg-nav-label">{ui.navigation}</div>
          <button type="button" className={`amg-nav-item ${activeStep === -1 ? "is-active" : ""}`} aria-current={activeStep === -1 ? "step" : undefined} onClick={() => selectStep(-1)}>
            <span className="amg-step-number">◎</span>
            <span>{copy.start}<small>{ui.intro}</small></span>
          </button>
          {copy.flow.map((label, index) => (
            <button key={index} type="button" className={`amg-nav-item ${activeStep === index ? "is-active" : ""}`} aria-current={activeStep === index ? "step" : undefined} onClick={() => selectStep(index)}>
              <span className="amg-step-number">{index + 1}</span>
              <span>{label}{(index === 1 || index === 2) && <small>{ui.optional}</small>}</span>
            </button>
          ))}
        </nav>

        <div className="amg-reading-column">
          <article className="amg-article" aria-labelledby="amg-step-title" aria-live="polite">
            <div className="amg-article-heading">
              <div className="amg-step-meta">
                <span>{step ? `${ui.step} ${activeStep + 1} ${ui.of} ${copy.steps.length}` : ui.intro}</span>
                {hasPaths && <span className="amg-optional">{ui.optional}</span>}
              </div>
              <h3 id="amg-step-title">{step ? step.title : copy.start}</h3>
              {!step && <p>{ui.introText}</p>}
            </div>
            <div className="amg-instructions">
              {!step && <div className="amg-preparation-label">{ui.count}</div>}
              <ol className="amg-instruction-list">
                {instructions.map((item, index) => {
                  if (hasPaths && (index === pathStart || index === pathStart + 1)) return null;
                  return <li key={index}>{item}</li>;
                })}
              </ol>
              {hasPaths && (
                <div className="amg-paths">
                  <section className="amg-path">
                    <h4>{ui.standard}</h4>
                    <span className="amg-button-label">{activeStep === 1 ? "Send doctor email / Download ZIP" : "Upload signed cert"}</span>
                    <p>{instructions[pathStart]}</p>
                  </section>
                  <section className="amg-path amg-path-skip">
                    <h4>{ui.skip}</h4>
                    <span className="amg-button-label">{activeStep === 1 ? "Skip generation & doctor email" : "Skip signed certificate upload → Confirm skip"}</span>
                    <p>{instructions[pathStart + 1]}</p>
                  </section>
                </div>
              )}
            </div>
            <footer className="amg-step-footer">
              <Button variant="outline-secondary" size="sm" disabled={activeStep === -1} onClick={() => selectStep(activeStep - 1)}>← {ui.previous}</Button>
              <span>{step ? `${activeStep + 1} / ${copy.steps.length}` : ui.intro}</span>
              <Button variant="primary" size="sm" onClick={() => selectStep(activeStep === copy.steps.length - 1 ? -1 : activeStep + 1)}>{activeStep === copy.steps.length - 1 ? ui.back : ui.next} →</Button>
            </footer>
          </article>

          <section className="amg-reference" aria-label={ui.reference}>
            <details>
              <summary>{copy.reminders}</summary>
              <ul>{copy.notes.map((item) => <li key={item}>{item}</li>)}</ul>
            </details>
            <details>
              <summary>{copy.permissions}</summary>
              <p>{copy.roles}</p>
            </details>
          </section>
        </div>
      </div>
    </div>
  );
};
export default AnnualMaskPurchaseGuide;
